export enum TalentAssessmentEnum {
  VIDEOS = "videos",
  TRYOUT = "tryout",
}

export enum ReviewCriteriaKey {
  // ===== Professional Expertise =====
  DOMAIN_KNOWLEDGE = "DOMAIN_KNOWLEDGE",
  TRACK_RECORD = "TRACK_RECORD",
  ANALYTICAL_SKILLS = "ANALYTICAL_SKILLS",
  TALENT_IDENTIFICATION = "TALENT_IDENTIFICATION",
  INNOVATION_METHODS = "INNOVATION_METHODS",

  // ===== Communication & Leadership =====
  LEADERSHIP = "LEADERSHIP",
  COMMUNICATION_CLARITY = "COMMUNICATION_CLARITY",
  TEAM_MANAGEMENT = "TEAM_MANAGEMENT",
  INFLUENCE_NETWORKING = "INFLUENCE_NETWORKING",
  CULTURAL_ADAPTABILITY = "CULTURAL_ADAPTABILITY",

  // ===== Professionalism & Work Ethic =====
  DISCIPLINE = "DISCIPLINE",
  WORK_RATE = "WORK_RATE",
  INTEGRITY_ETHICS = "INTEGRITY_ETHICS",
  RESILIENCE = "RESILIENCE",
  COACHABILITY = "COACHABILITY",
  PROFESSIONAL_PRESENCE = "PROFESSIONAL_PRESENCE",

  // ===== Development & Growth =====
  LEARNING_ORIENTATION = "LEARNING_ORIENTATION",
  ADAPTABILITY = "ADAPTABILITY",
  FUTURE_POTENTIAL = "FUTURE_POTENTIAL",
  SPECIALIZATION_FIT = "SPECIALIZATION_FIT",

  // ===== Talent - Technical Skills =====
  FIRST_TOUCH_RECEIVING = "FIRST_TOUCH_RECEIVING",
  PASSING_RANGE_ACCURACY = "PASSING_RANGE_ACCURACY",
  DRIBBLING_1V1 = "DRIBBLING_1V1",
  SHOOTING_FINISHING = "SHOOTING_FINISHING",
  CROSSING_DELIVERY = "CROSSING_DELIVERY",
  HEADING_TECHNIQUE = "HEADING_TECHNIQUE",

  // ===== Talent - Tactical Awareness =====
  POSITIONING = "POSITIONING",
  OFF_BALL_MOVEMENT = "OFF_BALL_MOVEMENT",
  DEFENSIVE_AWARENESS = "DEFENSIVE_AWARENESS",
  TRANSITION_PLAY = "TRANSITION_PLAY",
  SPATIAL_AWARENESS = "SPATIAL_AWARENESS",
  TACTICAL_ADAPTABILITY = "TACTICAL_ADAPTABILITY",

  // ===== Talent - Athleticism & Physical =====
  ACCELERATION = "ACCELERATION",
  TOP_SPEED = "TOP_SPEED",
  STRENGTH = "STRENGTH",
  ENDURANCE = "ENDURANCE",
  AGILITY = "AGILITY",
  FLEXIBILITY_COORDINATION = "FLEXIBILITY_COORDINATION",
  INJURY_RESISTANCE_RECOVERY = "INJURY_RESISTANCE_RECOVERY",

  // ===== Talent - Mindset & Psychological =====
  CONCENTRATION = "CONCENTRATION",
  CONFIDENCE = "CONFIDENCE",
  // LEADERSHIP, DISCIPLINE, WORK_RATE, RESILIENCE, COACHABILITY are already included above
  PROFESSIONALISM = "PROFESSIONALISM",
}

export enum CandidateAssessedVia {
  TRYOUT_INTERVIEW = "TRYOUT_INTERVIEW",
  VIDEO_ANALYSIS = "VIDEO_ANALYSIS",
  TECHNICAL_TEST = "TECHNICAL_TEST",
}
